__turbopack_context__.v({
  "accordionSlideOverwrite": "styles-module-scss-module__X715-a__accordionSlideOverwrite",
  "fadeIn": "styles-module-scss-module__X715-a__fadeIn",
  "fadeOut": "styles-module-scss-module__X715-a__fadeOut",
  "formContainer": "styles-module-scss-module__X715-a__formContainer",
  "image": "styles-module-scss-module__X715-a__image",
  "scaleIn": "styles-module-scss-module__X715-a__scaleIn",
  "scaleOut": "styles-module-scss-module__X715-a__scaleOut",
  "zoomIn": "styles-module-scss-module__X715-a__zoomIn",
  "zoomOut": "styles-module-scss-module__X715-a__zoomOut",
});
